import { jwtDecode } from 'jwt-decode'

const isTokenExpired = (token: string | null) => {
    if (!token) return true

    try {
        const decoded = jwtDecode(token)

        // Verifica se 'exp' existe no token
        if (!decoded || !decoded.exp) {
            return true // Se não existir, considera expirado
        }

        const currentTime = Date.now() / 1000 // Tempo atual em segundos
        return decoded.exp < currentTime // Retorna true se expirar
    } catch (error) {
        return true // Em caso de erro, trata como expirado
    }
}

export { isTokenExpired }
